export default __webpack_public_path__ + "static/media/43.1d8f9284.jpeg";